import type { ReactNode, VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { DependencyFilterKeys, LayerDepthFilterOptions } from '../../../../../../shared/dependenciesV2';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import FilterCardCheckboxes from '../../../../generic/Filter/FilterCardCheckboxes';
import type { SelectOption } from '../../../../../types';
import LabelWrapper from '../LabelWrapper';
import styles from '../Filters.module.less';
import { icons } from '../../../../generic/Icon';

// Filter labels by key value
const FILTER_LABELS: Record<LayerDepthFilterOptions, ReactNode> = {
  [LayerDepthFilterOptions.Base]: <LabelWrapper className={styles.FilterIcon} icon={icons.sendBackward} label="Base Layer" />,
  [LayerDepthFilterOptions.Other]: <LabelWrapper className={styles.FilterIcon} icon={icons.layerGroup} label="Other Layer" />,
};

// Built filter options for checkbox filter
const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) => ({
  label, value,
}));

/**
 * Layer depth filter which allows the user to filter dependencies by container layer:
 * base or other. Uses LayerDepthFilterOptions to generate the checkbox filter values.
 */
const LayerFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedOptions = (filters.layerDepth ?? []).map((option: LayerDepthFilterOptions) => ({
    label: FILTER_LABELS[option],
    value: option,
  }));

  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.LayerDepth]: selected.map((option) => option.value),
  });

  return (
    <FilterCardCheckboxes
      label="Layer"
      options={FILTER_OPTIONS}
      values={selectedOptions}
      onChange={onChange}
    />
  );
};

export default LayerFilter;
